import {
  FormControl,
  FormErrorMessage,
  FormLabel,
} from '@chakra-ui/form-control'
import { Input } from '@chakra-ui/input'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import React from 'react'

interface TextFieldProps<T> {
  name: keyof T
  label: string
  required?: boolean
  placeholder?: string
  isDisabled?: boolean
}

function TextField<T>({
  name,
  label,
  required,
  placeholder,
  isDisabled,
}: TextFieldProps<T>): React.ReactElement {
  return (
    <Field name={name}>
      {({ field, form }: FieldProps<string, T>) => (
        <FormControl
          name={field.name}
          isDisabled={isDisabled}
          isInvalid={Boolean(
            form.errors[field.name] && form.touched[field.name],
          )}
          isRequired={required}
        >
          <FormLabel>{label}</FormLabel>
          <Input {...field} placeholder={placeholder ?? label} />
          <FormErrorMessage>
            {form.errors[field.name]}
          </FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

export default TextField
